import { Translation } from "../i18n-types";

const ro: Translation = {
    "state-is-required": "Localitatea este câmp obligatoriu",
    description: {
        "show-more": "Afișați mai multe",
        "show-less": "Arata mai putin"
    },
    footer: {
        "why-shop-with-us": "Explicați în cuvintele dvs de ce ați recomanda magazinul nostru?",
        "heureka-image-url": "/footer/img/ro/comparator.png",
        benefits: {
            first: "Livrare foarte rapidă.",
            second: "Servicii rapide și de încredere.",
            third: "Abordare prietenoasă din partea serviciului pentru clienți."
        },
        social: {
            "facebook-plugin-url":
                "https://www.facebook.com/plugins/page.php?href=https%3A%2F%2Fwww.facebook.com%2Ffoxigy.ro&tabs&width=314&height=130&small_header=false&adapt_container_width=true&hide_cover=false&show_facepile=true&appId",
            "facebook-page-url": "https://www.facebook.com/foxigy.ro",
            "instagram-page-url": "https://www.instagram.com/foxigy.ro/",
            "youtube-page-url": "https://www.youtube.com/channel/UCJmYbCUJa0K8ibRY9dex8vA"
        },
        "your-foxigy-image-link": "/footer/img/ro/your-foxigy.png"
    }
};

export default ro;
